// ── Gathering system types and messages (Round 13 Phase B) ──
/** Gathering node types — each maps to a visual interaction in the world. */
export var GatherNodeType;
(function (GatherNodeType) {
    GatherNodeType["Tree"] = "tree";
    GatherNodeType["Rock"] = "rock";
    GatherNodeType["Grass"] = "grass";
    GatherNodeType["WaterSource"] = "water_source";
    GatherNodeType["InkStone"] = "ink_stone";
    GatherNodeType["HomeBench"] = "home_bench";
    GatherNodeType["Beehive"] = "beehive";
    GatherNodeType["FireResidue"] = "fire_residue";
    GatherNodeType["EmberVent"] = "ember_vent";
})(GatherNodeType || (GatherNodeType = {}));
/** Client -> Server: player begins gathering at a node. */
export const MSG_GATHER_START = 'gather_start';
/** Server -> Client: gathering completed, items granted. */
export const MSG_GATHER_COMPLETE = 'gather_complete';
/** Server -> Client: gathering was cancelled (player moved). */
export const MSG_GATHER_CANCELLED = 'gather_cancelled';
/** Server -> Client: a gather node exists at this position. */
export const MSG_GATHER_NODE_SPAWN = 'gather_node_spawn';
/** Server -> Client: a gather node entered cooldown. */
export const MSG_GATHER_NODE_COOLDOWN = 'gather_node_cooldown';
/** Interaction range for gathering nodes (px) — same as creek stones. */
export const GATHER_INTERACT_RANGE = 56;
//# sourceMappingURL=gathering.js.map